/**
 * configuration applied when BROCOLI_API_MODE = next
 */
module.exports = {}
